import { render, staticRenderFns } from "./LecturesRootView.vue?vue&type=template&id=03b12a31&scoped=true"
import script from "./LecturesRootView.vue?vue&type=script&lang=js"
export * from "./LecturesRootView.vue?vue&type=script&lang=js"
import style0 from "./LecturesRootView.vue?vue&type=style&index=0&id=03b12a31&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b12a31",
  null
  
)

export default component.exports